import Service from "../../AuthService";

const InvoicePayoff = {
    getInvoicePayoff(page, transaction_type_id) {
        //console.log("/invoice-payoff?page="+page+"&transaction_type_id="+transaction_type_id);
        return Service.get("/invoice-payoff?page=" + page + "&transaction_type_id=" + transaction_type_id);
    },
    createInvoicePayoff(data) {
        return Service.post("/invoice-payoff", data)
    },
    getInvoicePayoffById(id) {
        return Service.get("/invoice-payoff/" + id)
    },
    updateInvoicePayoff(id, data) {
        return Service.put("/invoice-payoff/" + id, data)
    },
    deleteInvoicePayoff(page, id, remark) {
        return Service.delete("/invoice-payoff/" + id + "?page=" + page + "&remark=" + remark);
    },
    getCustomerFromSale(sale_id) {
        return Service.get("/get_customer_from_sale/" + sale_id)
    },
    getInvoiceFormCustomer(customer_id, billing_id, invoice_id) {
        return Service.get("/get_invoice_by_billing?customer_id=" + customer_id +
            "&billing_id=" + billing_id +
            "&invoice_id=" + invoice_id
        );
    },
    getBillingPayoff(sale_id, customer_id) {
        return Service.get("/get_billing_payoff?sale_id=" + sale_id + "&customer_id=" + customer_id);
    },
    saveCreditCustomer(data) {
        return Service.post("/credit_customer", data)
    },
    savePayoffCreditCustomer(data) {
        return Service.post("/invoice_payoff_credit", data)
    },
    searchInvoicePayoff(page, data) {
        return Service.post("/payoff_search?page=" + page, data)
    },
    generateRV() {
        return Service.get('/generate_rv_number');
    },
    updateRv(data) {
        return Service.post('/update_rv_number', data);
    },
    approveStatus(id, data) {
        return Service.post(`/approve_status_invoice_payoff/${id}`, data);
    },
    printPayoffById(id, user_id) {
        return Service.get(`/payoff-pdf/${id}?user_print=${user_id}`);
    },
    validateRvNumber(rv_number, id) {
        return Service.get(`/validate_rv_number?rv_number=${rv_number}&id=${id}`)
    }
};

export default InvoicePayoff
